import React from 'react';
import { useSelector } from 'react-redux';
import { loginsToTableRowData } from '@/utils/mappers';
import { PaginatedTable } from '@lucky7ventures/lucky-components';
import { useIntl } from 'react-intl';
import Spinner from './UI/Spinner';
import { StyledPaginatedTable } from './StyledPaginatedTable';
import {
  selectLoginHistory,
  selectLoginHistoryLoading,
} from '@/store/selectors/loginHistorySelectors';
import { BffLoginHistory } from '@lucky7ventures/bff-types';
import { envIsCanada } from '@/constants/constants';
import { LoginHistoryCards } from './LoginHistoryCards';

export function LoginHistory(): JSX.Element {
  const loginHistory = useSelector(selectLoginHistory);
  const loading = useSelector(selectLoginHistoryLoading);
  const intl = useIntl();
  const noDataMsg = intl.formatMessage({ id: 'loginHistory.noDataMsg' });
  const headerCells = [
    intl.formatMessage({ id: 'history.loggedIn' }),
    intl.formatMessage({ id: 'history.loggedOut' }),
    ...(envIsCanada()
      ? [
          intl.formatMessage({ id: 'history.totalWagered' }),
          intl.formatMessage({ id: 'history.totalWon' }),
          intl.formatMessage({ id: 'history.totalLost' }),
          intl.formatMessage({ id: 'history.balanceStart' }),
          intl.formatMessage({ id: 'history.balanceEnd' }),
          intl.formatMessage({ id: 'history.netPosition' }),
          intl.formatMessage({ id: 'history.currency' }),
        ]
      : []),
  ];
  const loadingMsg = <Spinner width={20} height={20} dark />;

  if (loading) {
    return <div className="mt-4 flex justify-center">{loadingMsg}</div>;
  }

  return (
    <div id="e2e_loginHistory">
      {/* Desktop: table */}
      <StyledPaginatedTable className="hidden xl:block">
        <PaginatedTable<BffLoginHistory>
          noDataMsg={noDataMsg}
          dataRows={loginHistory}
          headerCells={headerCells}
          isLoading={loading}
          loadingMsg={loadingMsg}
          rowsMapper={loginsToTableRowData}
        />
      </StyledPaginatedTable>

      {/* Mobile + tablet: cards */}
      <div className="mt-4 xl:hidden">
        {loginHistory.length === 0 ? (
          <p className="text-center text-sm text-gray-500">{noDataMsg}</p>
        ) : (
          <LoginHistoryCards data={loginHistory} />
        )}
      </div>
    </div>
  );
}
